import { createFileRoute, notFound } from "@tanstack/react-router";

import { ServiceDetail, ServiceMissing } from "@/features/site/modules/service-detail/service-detail";
import type { TrainerLoaderData } from "@/features/site/utils/trainer-head";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/services/$slug/")({
  component: ServicePage,
  notFoundComponent: ServiceMissing,
  // A service the trainer does not have is a real 404, so search engines drop an old address.
  loader: async ({ params, parentMatchPromise }) => {
    // Named by hand: with its `head` reading the loader's data too, the router infers the layout's as `never`.
    const loaded = (await parentMatchPromise).loaderData as TrainerLoaderData | undefined;
    if (loaded && !loaded.directory.services.some((service) => service.id === params.slug)) throw notFound();
    return { crumb: m.landing_nav_services() };
  },
});

/** `$slug` is the booking service's id: the trainer's services have no names of their own to slug. */
function ServicePage() {
  const { slug } = Route.useParams();
  return <ServiceDetail serviceId={slug} />;
}
